export default "__VITE_ASSET__D0UDBItG__"